<template>
  <div class="form-group translatable-field">
    <div class="d-flex align-items-center mb-1">
      <label class="m-0">{{ label }} <span class="text-muted">· {{ lang.toUpperCase() }}</span></label>
      <el-button
        v-if="!readOnly && lang !== sourceLang && !current && source"
        type="text"
        size="mini"
        class="ml-auto p-0"
        @click="update(source)"
      >Copy from {{ sourceLang.toUpperCase() }}</el-button>
    </div>

    <!-- one editor, re-created per language: 13 CKEditor instances at once make the page crawl -->
    <ckeditor
      v-if="type === 'wysiwyg'"
      :key="`${lang}-${readOnly}`"
      :value="current"
      :config="{ allowedContent: true, readOnly }"
      :read-only="readOnly"
      @input="update"
    />
    <el-input
      v-else
      :disabled="readOnly"
      :value="current"
      :type="type === 'textarea' ? 'textarea' : 'text'"
      :autosize="type === 'textarea' ? { minRows: 2, maxRows: 8 } : undefined"
      :maxlength="maxlength"
      :show-word-limit="!!maxlength"
      @input="update"
    />
  </div>
</template>

<script>
/**
 * One translatable metadata field ({ lang: text }) showing the language picked by the block's
 * LangSwitch. Emits the whole translations object, so the parent keeps plain v-model.
 */
export default {
  name: "TranslatableField",
  props: {
    readOnly: { type: Boolean, default: false },
    value: { type: Object, default: () => ({}) },
    lang: { type: String, required: true },
    label: { type: String, required: true },
    // text | textarea | wysiwyg
    type: { type: String, default: "text" },
    maxlength: { type: Number, default: undefined },
    sourceLang: { type: String, default: "en" },
  },
  computed: {
    current() {
      return (this.value && this.value[this.lang]) || "";
    },
    source() {
      return (this.value && this.value[this.sourceLang]) || "";
    },
  },
  methods: {
    update(text) {
      if (this.readOnly) return;
      this.$emit("input", { ...this.value, [this.lang]: text });
    },
  },
};
</script>
